<template>
  <div class="v-level --is-level-1 --is-mobile">
    <Heading title="Fertige Präsente" subtitle="Thematisch perfekt abgestimmt." level="1" />

    <LevelCatalog
      ref="catalog"
      :listItems="$store.getters.getListItemsLevel1Filtered.filter(function(product) {
            const price = getPriceRawForGroup(product, $store.getters.getUserGroupId, !$store.getters.getLevel1Filter.useB2cPrices) + getBoxPriceLvl1(product, $store.getters.getUserGroupId, !$store.getters.getLevel1Filter.useB2cPrices);
            if (
                price >= $store.getters.getLevel1Filter.priceMin &&
                price <= $store.getters.getLevel1Filter.priceMax
            ) {
                return true;
            }
            return false;
        })"
    />
  </div>
</template>

<script>
import Heading from '@/components/Heading';
import LevelCatalog from '@/components/LevelCatalog';
import { logicMixin } from '@/mixins/LogicMixin';

export default {
  components: {
    Heading,
    LevelCatalog
  },
  mixins: [logicMixin]
};
</script>

<style lang="scss" scoped>
$component: '--is-level-1';

.#{$component} {
  .duplex__left {
    border-right: 0;
    padding-right: 0.5rem;
  }

  ::v-deep {
    .panel {
      border-top-right-radius: $border-radius;
      border-bottom-right-radius: $border-radius;

      &.--is-catalog {
        margin-right: 0;
      }
    }
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    ::v-deep {
      .level-catalog__list > li {
        margin-bottom: 8%;
      }
    }
  }
}
</style>
